import { render, staticRenderFns } from "./RegistrationByMatrixCard.vue?vue&type=template&id=dd4fc37e&scoped=true&"
import script from "./RegistrationByMatrixCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationByMatrixCard.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationByMatrixCard.vue?vue&type=style&index=0&id=dd4fc37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4fc37e",
  null
  
)

export default component.exports